import { render, staticRenderFns } from "./CoronaIcon.vue?vue&type=template&id=f586f820"
import script from "./CoronaIcon.vue?vue&type=script&lang=js"
export * from "./CoronaIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports